import _isPlainObject from 'lodash.isplainobject'

/*
  Treats a missing key and an explicit `undefined` as equal, which is how
  submission data behaves - clearing a field writes `undefined` rather than
  deleting the key.
*/
export default function isDeepEqual(a: unknown, b: unknown): boolean {
  if (Object.is(a, b)) return true

  if (Array.isArray(a) && Array.isArray(b)) {
    return (
      a.length === b.length && a.every((item, i) => isDeepEqual(item, b[i]))
    )
  }

  if (_isPlainObject(a) && _isPlainObject(b)) {
    const objectA = a as Record<string, unknown>
    const objectB = b as Record<string, unknown>
    const keys = new Set([...Object.keys(objectA), ...Object.keys(objectB)])
    for (const key of keys) {
      if (!isDeepEqual(objectA[key], objectB[key])) return false
    }
    return true
  }

  return false
}
